<template>
  <a-card class='content' :bordered='false'>
    <h6 class='m-b-25'>数据概况 <span></span></h6>
    <a-radio-group button-style="solid" @change="initData" v-model:value="search.day_type">
      <a-radio-button :value="1">昨日</a-radio-button>
      <a-radio-button :value="2">7天</a-radio-button>
      <a-radio-button :value="3">30天</a-radio-button>
    </a-radio-group>
    <div class="data-content m-t-25 m-b-25">
      <div class="data-content-nav s_flex_ali">
        <div class="data-content-nav-item flex_1 s_flex_center" :class="active==5?'active':''" @click="changNav(5,'新增业务员')">
          <div>
            <p class='title'>业务员数</p>
            <p class='num'>{{tabData.brand_sale.all_count || 0}}</p>
            <p><img src="@/assets/images/customer/new.png" alt="">{{tabData.brand_sale.seven_count || 0}}</p>
            <!-- <p><img src="@/assets/images/customer/total.png" alt="">{{tabData.member.allMemberCount || 0}}</p> -->
          </div>
        </div>
        <div class="data-content-nav-item flex_1 s_flex_center" :class="active==2?'active':''" @click="changNav(2,'新增经销商')">
          <div>
            <p class='title'>经销商数</p>
            <p class='num'>{{tabData.dealer.allDealerCount || 0}}</p>
            <p><img src="@/assets/images/customer/new.png" alt="">{{tabData.dealer.sevenDealerCount || 0}}</p>
            <!-- <p><img src="@/assets/images/customer/total.png" alt="">{{tabData.dealer.allDealerCount || 0}}</p> -->
          </div>
        </div>
        <div class="data-content-nav-item flex_1 s_flex_center" :class="active==3?'active':''" @click="changNav(3,'新增门店')">
          <div>
            <p class='title'>门店数</p>
            <p class='num'>{{tabData.store.allStoreCount || 0}}</p>
            <p><img src="@/assets/images/customer/new.png" alt="">{{tabData.store.sevenStoreCount || 0}}</p>
            <!-- <p><img src="@/assets/images/customer/total.png" alt="">{{tabData.store.allStoreCount || 0}}</p> -->
          </div>
        </div>
        <div class="data-content-nav-item flex_1 s_flex_center" :class="active==4?'active':''" @click="changNav(4,'新增店员')">
          <div>
            <p class='title'>店员数</p>
            <p class='num'>{{tabData.storeClerk.allStoreClerkCount || 0}}</p>
            <p><img src="@/assets/images/customer/new.png" alt="">{{tabData.storeClerk.sevenStoreClerkCount || 0}}
            </p>
            <!-- <p><img src="@/assets/images/customer/total.png" alt="">{{tabData.storeClerk.allStoreClerkCount || 0}}</p> -->
          </div>
        </div>
      </div>
      <a-spin :spinning='listLoading'>
        <div :class='listLoading? "p-t-150":""'>
          <div class="s_wid100">
            <div ref="charts" style="width: 100%; height: 500px"></div>
          </div>
        </div>
      </a-spin>
    </div>
  </a-card>
</template>
<script>
import { ref, reactive, onMounted, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getDealerGeneral } from "@/api/dealer";
import { iscode } from "@/utils/app";
import echarts from "echarts";
export default {
  name: "customer",
  components: {},
  setup() {
    const active = ref(2);
    const search = ref({
      day_type: 1,
      type: 1,
    });
    const state = reactive({
      activeName: "新增经销商",
      tabData: {
        brand_sale: {},
        dealer: {},
        store: {},
        storeClerk: {},
      },
      lineData: {
        timeData: [],
        lineList: [],
      },
      listLoading: false,
    });
    const charts = ref(null);
    var myChart;
    const renderEcharts = () => {
      myChart = echarts.init(charts.value);
      myChart.setOption({
          title: {
          text:   state.activeName
        },
         tooltip: {
              trigger: 'axis',
            },
        xAxis: {
          type: "category",
          data: state.lineData.timeData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: state.lineData.lineList,
            type: "line",
            smooth: true
          },
        ],
      });
      window.addEventListener("resize", function () {
        myChart.resize();
      });
      window.removeEventListener("resize", function () {
        myChart.resize();
      });
    };
    const initData = async () => {
      state.listLoading = true;
      let res = await getDealerGeneral(search.value)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        state.tabData = res.data.list;
        var timeData = res.data.lineList.latelyDays;
        var lineList = res.data.lineList.count;
        state.lineData = { timeData, lineList };
      } else {
        message.error(res.msg);
      }
      state.listLoading = false;
      renderEcharts();
    };
    const changNav = (current, name) => {
      active.value = current;
      state.activeName = name;
      search.value.type=current
      initData();
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      active,
      changNav,
      search,
      initData,
      charts,
    };
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 0px 15px;

  h6 {
    font-size: 16px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    color: #000;

    span {
      font-size: 12px;
      color: #8e8e8e;
      font-weight: 400;
    }
  }

  .data-content {
    min-height: 643px;

    .data-content-nav {
      background: #fbfcfc;
      border-radius: 10px;

      .data-content-nav-item {
        color: #8e8e8e;
        font-size: 14px;
        padding-top: 10px;
        padding-bottom: 10px;
        cursor: pointer;

        .title {
          font-size: 16px;
          color: #000000;
        }

        .num {
          font-size: 34px;
          color: #000;
        }

        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }

        &.active {
          background-color: #fff;
          box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
        }
      }
    }
  }
}
</style>